<template>
  <div class="home">
    <div class="nav">
      <div class="nav-loge">
        <img src="../../assets/image/logo-mini.png" alt="logo" style="width: 110px" />
      </div>
      <div class="nav-ttile">进校预约系统</div>
    </div>
    <div class="main">
      <div class="bgheader"></div>
      <div class="form-bg">
        <div class="form-container">
          <van-form @submit="onSubmit" validate-firs @failed="onFailed">
            <div class="card">
              <div class="card-title">
                <van-icon class-prefix="my-icon" name="hezuowoshou" color="#12CBC4" />
                <div class="card-text" style="margin-left: 2px">被访人信息</div>
                <div class="card-star">*</div>
              </div>
              <div class="drxx">
                <van-checkbox v-model="drxx" shape="square">是否自动带入上一条预约信息</van-checkbox>
              </div>
              <van-field v-model="bfrdh" name="bfrdh" label="被访人电话" placeholder="被访人电话" @blur="bfrdhClick" :rules="[{ required: true }]" />
              <van-field v-model="bfrxm" name="bfrxm" label="被访人姓名" placeholder="被访人姓名" readonly />
              <div class="flex">
                <van-field v-model="bfrdwmc" name="bfrdwmc" label="被访人单位" placeholder="被访人单位" :readonly="dwReadonly" />
              </div>
            </div>
            <div class="card">
              <div class="card-title">
                <van-icon class-prefix="my-icon" name="xiangqing" color="#12CBC4" />
                <div class="card-text">访客详情</div>
                <div class="card-star">*</div>
              </div>
              <van-field readonly clickable name="dfdd" :value="dfdd" label="到访地点" placeholder="选择到访地点" @click="showPickerDd = true" />
              <van-popup v-model="showPickerDd" position="bottom">
                <van-picker show-toolbar :columns="columns" @confirm="onConfirmDd" @cancel="showPickerDd = false" />
              </van-popup>
              <van-field
                readonly
                clickable
                name="fwkssj"
                :value="fwkssj"
                label="访问开始时间"
                placeholder="选择开始时间"
                @click="showPickerKssj = true"
                :rules="[{ required: true, message: '请选择访问开始时间' }]"
              />
              <van-popup v-model="showPickerKssj" position="bottom">
                <van-datetime-picker type="date" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmKssj" @cancel="showPickerKssj = false" />
              </van-popup>
              <!-- <van-field
                v-model="fwts"
                name="fwts"
                label="访问天数"
                placeholder="访问天数"
                :rules="[
                  { required: true, message: '请填写访问天数' },
                  {
                    pattern: /^[1-3]{1}$/,
                    message: '请输入1-3之间的任意一个数字',
                  },
                ]"
              /> -->
              <van-field name="fwts" label="访问天数">
                <template #input>
                  <van-stepper v-model="fwts" min="1" max="2" />
                </template>
              </van-field>
              <van-field
                v-model="bfsy"
                name="bfsy"
                label="拜访事由"
                placeholder="填写拜访事由"
                type="textarea"
                rows="2"
                :rules="[{ required: true, message: '请填写拜访事由' }]"
              />
            </div>
            <div class="card">
              <div class="card-title">
                <!--                            <van-icon name="cart-o" color="#1989fa" />-->
                <van-icon class-prefix="my-icon" name="CombinedShape" color="#12CBC4" />
                <div class="card-text">访客信息</div>
                <div class="card-star">*</div>
              </div>
              <van-field v-model="fkxm" name="fkxm" label="访客姓名" placeholder="访客姓名" :rules="[{ required: true, message: '请填写访客姓名' }]" />
              <van-field v-model="fkdh" name="fkdh" label="访客电话" placeholder="访客电话" :rules="[{ required: true, message: '请填写访客电话' }]" />
              <van-field readonly clickable name="zjlx" :value="zjlx" label="证件类型" placeholder="选择证件类型" @click="showPickerZjlx = true" />
              <van-popup v-model="showPickerZjlx" position="bottom">
                <van-picker show-toolbar :columns="columnsZjlx" @confirm="onConfirmZjlx" @cancel="showPickerZjlx = false" />
              </van-popup>
              <van-field
                v-model="zjhm"
                name="zjhm"
                label="证件号码"
                placeholder="证件号码"
                :rules="[
                  { required: true, message: '请填写证件号码' },
                  { validator, message: '请正确填写' },
                ]"
              />
              <van-field
                v-model="fkszdw"
                name="fkszdw"
                label="访客所在单位"
                placeholder="访客所在单位"
                :rules="[{ required: true, message: '请填写访客所在单位' }]"
              />
            </div>
            <div class="card" v-show="cphShow">
              <div class="card-title">
                <van-icon class-prefix="my-icon" name="cheliangxinxi" color="#12CBC4" />
                <div class="card-text" style="margin-left: 2px">车辆信息</div>
              </div>
              <van-collapse v-model="activeCl">
                <van-collapse-item title="若有随行车辆，请点击输入随行车辆" name="1" :lazy-render="false">
                  <van-field
                    style="padding-left: 0px"
                    v-model="clhm"
                    name="clhm"
                    label="车辆号码"
                    placeholder="车辆号码"
                    @focus="clClick"
                    :disabled="disabled"
                  />
                </van-collapse-item>
              </van-collapse>
            </div>
            <!-- <div class="card">
              <div class="card-title">
                <img src="../../assets/image/ddc.png" alt="" style="width: 21px" />
                <div class="card-text" style="margin-left: 2px">电动自行车入校</div>
              </div>
              <van-field v-model="ddcph" name="ddcph" label="电动自行车车牌号" label-width="116" placeholder="请输入电动自行车车牌号" :disabled="disabled" />
            </div> -->
            <div class="card">
              <div class="card-title">
                <van-icon class-prefix="my-icon" name="shenfenxinxi" color="#12CBC4" />

                <div class="card-text" style="margin-left: 2px">学生信息</div>
              </div>
              <van-collapse v-model="activeName">
                <van-collapse-item title="若您是学生家长，请务必填写学生信息" name="2" :lazy-render="false">
                  <van-field style="padding-left: 0px" v-model="xsxh" name="xsxh" label="学生学号" placeholder="学生学号" :rules="[{}]" @blur="xhClick" />
                  <van-field style="padding-left: 0px" v-model="xsxm" name="xsxm" label="学生姓名" placeholder="学生姓名" :rules="[{}]" readonly />
                  <van-field style="padding-left: 0px" v-model="xsyx" name="xsyx" label="学生院系" placeholder="学生院系" :rules="[{}]" readonly />
                </van-collapse-item>
              </van-collapse>
            </div>
            <van-button type="info" block style="margin-bottom: 10px" color="rgb(25 97 194)" native-type="submit">提交</van-button>
            <van-button type="default" block style="margin-bottom: 70px" to="/notice" native-type="button">返回入口</van-button>
          </van-form>
        </div>
      </div>
    </div>

    <van-tabbar route>
      <van-tabbar-item replace to="/home" icon="home-o">预约申请</van-tabbar-item>
      <!--            <van-tabbar-item replace to="/visitor" icon="manager-o">游客预约</van-tabbar-item>-->
      <van-tabbar-item replace :to="{ name: 'applied', params: { openid: openid } }" icon="orders-o">预约列表</van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="popShow" class="radioPop" ref="pop" @close="onCancel">
      <div>
        <van-search v-model="searchValue" show-action placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-radio-group v-model="bfrdw" @change="radioChange" v-show="showRadio" :style="{ height: searchListHight, overflow: 'scroll' }">
          <van-cell-group>
            <van-cell
              v-for="item in dwInfo"
              :title="item.DEPT_NAME"
              clickable
              @click="bfrdwmc = item.DEPT_NAME"
              :title-style="{ color: '#323233' }"
              :key="item.DEPT_NAME"
            >
              <template #right-icon>
                <van-radio :name="item.DEPT_CODE" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <div style="padding: 10px; padding-bottom: 12px" ref="btn">
        <van-button type="info" block @click="onCancel">确定</van-button>
      </div>
    </van-popup>
    <van-dialog v-model="dialogShow" title="信息确认" show-cancel-button @confirm="submitData">
      <van-form>
        <van-field v-model="fkxm" name="fkxm" label="访客姓名" readonly />
        <van-field v-model="fkdh" name="fkdh" label="访客电话" readonly />
        <van-field v-model="fwkssj" name="fwkssj" label="访问开始时间" readonly />
        <van-field v-model="zjhm" name="zjhm" label="证件号码" readonly />
        <van-field v-model="clhm" name="clhm" label="车辆号码" readonly v-if="clhm" />
        <!-- <van-field v-model="ddcph" name="ddcph" label="电动自行车车牌" readonly v-if="ddcph" label-width="100" /> -->
      </van-form>
    </van-dialog>

    <div class="panel-wrap" v-if="isShow" data-value="exit">
      <div class="animation-scale-up vehicle-panel" :style="{ background: backgroundColor }">
        <div class="so-plate-body">
          <div class="so-plate-word" :class="{ active: inputCPH.length == 0 }">
            <span>{{ cphArr[0] || "" }}</span>
          </div>
          <div class="so-plate-word" :class="{ active: inputCPH.length == 1 }">
            <span>{{ cphArr[1] || "" }}</span>
          </div>
          <div class="so-plate-dot"></div>
          <div class="so-plate-word" :class="{ active: inputCPH.length == 2 }">
            <span>{{ cphArr[2] || "" }}</span>
          </div>
          <div class="so-plate-word" :class="{ active: inputCPH.length == 3 }">
            <span>{{ cphArr[3] || "" }}</span>
          </div>
          <div class="so-plate-word" :class="{ active: inputCPH.length == 4 }">
            <span>{{ cphArr[4] || "" }}</span>
          </div>
          <div class="so-plate-word" :class="{ active: inputCPH.length == 5 }">
            <span>{{ cphArr[5] || "" }}</span>
          </div>
          <div class="so-plate-word" :class="{ active: inputCPH.length == 6 }">
            <span>{{ cphArr[6] || "" }}</span>
          </div>
          <div
            class="so-plate-word xinneng"
            :class="{
              active: inputCPH.length == 7,
              srwc: inputCPH.length == 8,
            }"
          >
            <p style="color: #bdc0c5" v-if="!cphArr[7]">+</p>
            <p v-if="!cphArr[7]">新能源</p>
            <span v-if="cphArr[7]">{{ cphArr[7] }}</span>
          </div>
        </div>
        <div class="topItem">
          <!-- <span class='check' @click='check'>中/英</span> -->
          <span class="check">软键盘</span>
          <!-- <span class='contentShow'>{{inputCPH}}</span> -->
          <span class="exit" @click="vehicleTap('exit')">取消</span>
        </div>
        <div class="keyword">
          <!--省份简写键盘-->
          <div v-if="keyBoardType === 1">
            <div class="vehicle-panel-row">
              <div
                class="vehicle-panel-row-button"
                :style="{ border: buttonBorder }"
                v-for="(item, idx) in keyVehicle1"
                @click="vehicleTap(item)"
                :key="idx + item"
              >
                {{ item }}
              </div>
            </div>
            <div class="vehicle-panel-row">
              <div
                class="vehicle-panel-row-button"
                :style="{ border: buttonBorder }"
                v-for="(item, idx) in keyVehicle2"
                @click="vehicleTap(item)"
                :key="idx + item"
              >
                {{ item }}
              </div>
            </div>
            <div class="vehicle-panel-row">
              <div
                class="vehicle-panel-row-button"
                :style="{ border: buttonBorder }"
                v-for="(item, idx) in keyVehicle3"
                @click="vehicleTap(item)"
                :key="idx + item"
              >
                {{ item }}
              </div>
              <div :style="{ border: buttonBorder }" class="vehicle-panel-row-button vehicle-panel-row-button-img">
                <img src="../../assets/image/shanchu.png" class="vehicle-en-button-delete" @click="vehicleTap('delete')" mode="aspectFit" />
              </div>
            </div>

            <div class="vehicle-panel-row-last">
              <div
                class="vehicle-panel-row-button vehicle-panel-row-button-last"
                @click="vehicleTap(item)"
                v-for="(item, idx) in keyVehicle4"
                :style="{ border: buttonBorder }"
                :key="idx + item"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <!--英文键盘  -->
          <div v-else class="ywkeyword">
            <div class="vehicle-panel-row" v-show="!(inputCPH.length == 1)">
              <div
                class="vehicle-panel-row-button vehicle-panel-row-button-number"
                @click="vehicleTap(item)"
                v-for="(item, idx) in keyNumber"
                :style="{ border: buttonBorder }"
                :key="item + idx"
              >
                {{ item }}
              </div>
            </div>
            <div class="vehicle-panel-row">
              <div
                class="vehicle-panel-row-button"
                :style="{ border: buttonBorder }"
                v-for="(item, idx) in keyEnInput1"
                @click="vehicleTap(item)"
                :key="idx + item"
              >
                {{ item }}
              </div>
            </div>
            <div class="vehicle-panel-row">
              <div
                class="vehicle-panel-row-button"
                :style="{ border: buttonBorder }"
                v-for="(item, idx) in keyEnInput2"
                @click="vehicleTap(item)"
                :key="idx + item"
              >
                {{ item }}
              </div>
              <div :style="{ border: buttonBorder }" class="vehicle-panel-row-button vehicle-panel-row-button-img">
                <img src="../../assets/image/shanchu.png" class="vehicle-en-button-delete" @click="vehicleTap('delete')" mode="aspectFit" />
              </div>
            </div>
            <div class="vehicle-panel-row-last">
              <div
                class="vehicle-panel-row-button vehicle-panel-row-button-last"
                @click="vehicleTap(item)"
                :style="{ border: buttonBorder }"
                v-for="(item, idx) in keyEnInput3"
                :key="idx + item"
              >
                {{ item }}
              </div>
              <div :style="{ border: buttonBorder }" class="vehicle-panel-row-button vehicle-panel-ok" @click="vehicleTap('ok')">确定</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  Icon,
  Form,
  Field,
  Picker,
  Popup,
  DatetimePicker,
  Collapse,
  CollapseItem,
  Toast,
  Button,
  Uploader,
  Search,
  Cell,
  CellGroup,
  RadioGroup,
  Dialog,
  Radio,
  Tabbar,
  TabbarItem,
  ImagePreview,
  Stepper,
  Checkbox,
} from "vant";
// eslint-disable-next-line
import szblMCom from "szblMCom";

export default {
  name: "index",
  components: {
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Search.name]: Search,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Stepper.name]: Stepper,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      ddcph: "", //电动车车牌号到访车辆
      bfrxm: "", //被访人姓名
      bfrdh: "", //被访人电话
      bfrdw: "", //被访人单位code
      bfrdwmc: "", //被访人单位名称
      dwInfo: [], //单位信息查询数组
      dfdd: "海甸校区教学区", //到访地点
      fwkssj: "", //访问开始时间
      fwjssj: "", //访问结束时间
      fwts: "1", //访问天数
      bfsy: "", //拜访事由
      fkxm: "", //访客姓名
      fkdh: "", //访客电话
      zjlx: "身份证", //证件类型
      zjhm: "", //证件号码
      fkszdw: "", //访客所在单位
      clhm: "", //车辆号码
      xsxh: "", //学生学号
      xsxm: "", //学生姓名
      xsyx: "", //学生院系
      jkm: "", //健康码
      xcm: "", //行程码
      hsbg: "", //核酸报告
      uploaderhsbg: [], //核酸报告数组
      uploaderjkm: [], //健康码素组
      //行程码
      uploaderxcm: [], //行程码
      openid: "",
      // openid: "oUMdiuGvS-RWAw7qZUoqwDbZuYLc",
      columns: ["海甸校区教学区", "海甸校区家属区", "儋州校区", "观澜湖校区"],
      columnsZjlx: ["身份证", "军官证", "护照", "港澳通行证"],
      showPickerDd: false,
      showPickerKssj: false,
      showPickerJssj: false,
      showPickerZjlx: false,
      showRadio: false,
      dialogShow: false, //确认弹出框显示
      minDate: new Date(this.getDateFun().replace(/-/g, "/").split(" ")[0]),
      maxDate: new Date(this.nextDateFun()),
      activeName: [], //学生信息是否展开2
      activeddCl: [], //电动自行车是否展开3
      activeCl: [], //车辆信息是否展开1
      infoList: [], //信息列表
      listData: [], //已申请信息
      bfrInfo: [],
      searchValue: "",
      dwReadonly: true,
      //车牌键盘
      disabled: false, //车辆预约是否禁止
      isShow: false, //车辆软键盘显示
      popShow: false, //搜索弹出框显示
      cphArr: ["琼"], //车牌号值数组
      inputCPH: "琼",
      keyVehicle1: ["琼", "京", "津", "沪", "冀", "豫", "云", "辽"],
      keyVehicle2: ["黑", "湘", "皖", "鲁", "新", "苏", "浙", "赣"],
      keyVehicle3: ["鄂", "桂", "甘", "晋", "蒙", "吉", "闽"],
      keyVehicle4: ["粤", "川", "青", "藏", "陕", "宁", "贵", "渝"],
      keyNumber: "1234567890",
      keyEnInput1: "QWERTYUIOP",
      keyEnInput2: "ASDFGHJKL",
      keyEnInput3: "ZXCVBNM",
      backgroundColor: "#fff",
      keyBoardType: 2,
      buttonBorder: "1px solid #ccc",
      searchListHight: "342px",
      clDilog: false,
      cphShow: true,
      pzData: {},
      isRqYY: false,
      isVerify: true, //是否身份校验通过
      drxx: false, // 是否带入信息
    };
  },
  created() {},
  mounted() {
    this.readLocalStorage();
    this.getSJPz();
  },
  watch: {
    fwkssj(newval, oldval) {
      console.log(newval, oldval);
      if (newval) {
        this.checkRepeat();
      }
    },
    fwts(newval) {
      // console.log(typeof newval, oldval);
      if (parseInt(newval) > 3) {
        Toast("预约天数不能大于3天！");
        this.fwts = "3";
      }
    },
    dfdd(newval) {
      // console.log('到访地点',newval, oldval)
      if (newval == "儋州校区") {
        this.cphShow = false;
        this.clhm = "";
      } else {
        this.cphShow = true;
      }
    },
    bfrdh(newval) {
      if (newval && newval.length > 11) {
        let reg = /[\t\r\f\n\s]*/g;
        this.bfrdh = newval.replace(reg, "");
      }
    },
    fkdh(newval) {
      if (newval && newval.length > 11) {
        let reg = /[\t\r\f\n\s]*/g;
        this.fkdh = newval.replace(reg, "");
      }
    },
    clhm(newval) {
      if (newval.length >= 7) {
        let pzdata = this.pzData;
        this.getRqjy(this.fwkssj, this.jssjDateFun(this.fwts));
        if (!this.isRqYY) {
          if (pzdata.JZYY_KS == pzdata.JZYY_JS) {
            Toast(`${pzdata.JZYY_KS}的日期，车辆不可预约`);
          } else {
            Toast(`${pzdata.JZYY_KS}到${pzdata.JZYY_JS}的日期，车辆不可预约`);
          }

          this.clhm = "";
          this.inputCPH = "琼";
          this.cphArr = ["琼"];
        }
      }
    },
    drxx(newval) {
      if (!newval) {
        this.bfrdh = "";
        this.bfrdw = "";
        this.bfrdwmc = "";
        this.bfrxm = "";
        this.fkxm = "";
        this.fkdh = "";
        this.fkszdw = "";
        this.clhm = "";
        return;
      }
      const data = this.listData[0];
      if (!data) return;
      this.bfrdh = data.BFRDH;
      this.bfrdhClick();
      this.fkxm = data.FKXM;
      this.fkdh = data.FKDH;
      this.fkszdw = data.FKSZDW;
      this.clhm = data.CLHM;
    },
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    showDialog() {
      // console.log(333);
      let text =
        "1.校园内限速30km/h，超速行驶、乱停乱放、闯红灯的车辆将被列入黑名单，禁止进入校园。2.新南门不设缴费点，缴费车辆从北门、东门出校。3.需要缴费的车辆请提前扫码缴费( 2小时内有效 )，避免造成校门拥堵。4.根据管理规定，无校园通行证的电动自行车一律不得进入校园，确因工作需要骑电动自行车进入校园的，请到保卫处办理通行手续。";
      Dialog.alert({
        title: "预约车辆温馨提示",
        message: text,
        // theme: 'round-button',
        confirmButtonText: "我已知晓",
        confirmButtonColor: "rgb(25, 97, 194)",
        messageAlign: "left",
        showCancelButton: true,
      })
        .then(() => {})
        .catch(() => {
          this.$router.push({ name: "notice" });
        });
    },
    deletejkm() {
      // console.log('uploaderhsbg',this.uploaderhsbg)
      this.jkm = "";
    },
    deletexcm() {
      this.xcm = "";
    },
    deletehsbg() {
      this.hsbg = "";
    },
    imgePre() {
      ImagePreview([require("../../assets/image/hsbg.jpg")]);
    },
    //读取本地
    readLocalStorage() {
      let openidJson = localStorage.getItem("openidStorage");
      if (typeof openidJson == "string" && openidJson !== null) {
        this.openid = JSON.parse(openidJson).openid;
        this.getListData();
        // console.log('openid',this.openid)
      } else {
        this.getOpenId();
      }

      let json = localStorage.getItem("fkStorage");
      let obj;
      if (json !== "[object Object]" && json !== null) {
        obj = JSON.parse(json);
      }
      if (obj != null) {
        this.fkxm = obj.fkxm;
        this.fkdh = obj.fkdh;
        this.zjlx = obj.zjlx;
        this.zjhm = obj.zjhm;
        this.fkszdw = obj.fkszdw;
      }
      this.showDialog();
    },
    saveLocalStorage() {
      let fkInfo = {
        fkxm: this.fkxm,
        fkdh: this.fkdh,
        zjlx: this.zjlx,
        zjhm: this.zjhm,
        fkszdw: this.fkszdw,
        // jkm:this.jkm,
        // xcm:this.xcm,
        clhm: this.clhm,
      };
      // console.log('fkInfoe', fkInfo)
      // localStorage.removeItem("fkStorage");
      localStorage.setItem("fkStorage", JSON.stringify(fkInfo));
      // let json = localStorage.getItem("fkStorage")
      this.clearData();
      // console.log(json === '[object Object]', json)
      // let obj;
      // if (json !== '[object Object]' && json !== null) {
      //     obj = JSON.parse(json)
      // }
      // window.location.reload();//刷新页面
      // console.log('savelocolStorage', obj)
    },

    uploadImage(file, str) {
      let _this = this;
      file.status = "uploading";
      file.message = "上传中...";
      // let _this=this;
      let urlImg = "";
      let obj = {
        photo: file.content,
        len: file.content.length,
      };
      let arr = [];
      arr.push(obj);
      // console.log(obj)
      let url = "https://wyy.hainanu.edu.cn/NKSJ";
      szblMCom
        .ajaxPost("/api/media/verifyNo/img?u=jxyy", arr)
        .then(function (res) {
          // console.log('res)', res)

          if (res.code == 0) {
            if (res.data === "图片存储失败" || res.msg === "图片存储失败") {
              if (str === "xcm") {
                _this.xcm = "";
              } else if (str === "jkm") {
                _this.jkm = "";
              } else if (str === "hsbg") {
                _this.hsbg = "";
              }
              file.status = "failed";
              file.message = "上传失败,已自动通知管理员";
              Toast("图片上传失败，已经自动发送给管理员");
            } else {
              urlImg = url + JSON.parse(res.data)[0];
              file.status = "done";
              // file.message = '上传成功';
              // console.log('图片上传成功', urlImg)
              if (str === "xcm") {
                _this.xcm = urlImg;
              } else if (str === "jkm") {
                _this.jkm = urlImg;
              } else if (str === "hsbg") {
                _this.hsbg = urlImg;
              }
            }
          } else {
            if (str === "xcm") {
              _this.xcm = "";
            } else if (str === "jkm") {
              _this.jkm = "";
            } else if (str === "hsbg") {
              _this.hsbg = "";
            }
            file.status = "failed";
            file.message = "上传失败";
            Toast("图片上传失败");
          }
        })
        .catch(function (msg) {
          if (str === "xcm") {
            _this.xcm = "";
          } else if (str === "jkm") {
            _this.jkm = "";
          } else if (str === "hsbg") {
            _this.hsbg = "";
          }
          file.status = "failed";
          file.message = "上传失败";
          Toast(msg);
        });
      // return urlImg
    },
    getOpenId() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中...",
      });
      if (this.$route.params.openid || this.openid) {
        if (this.$route.params.openid) {
          this.openid = this.$route.params.openid;
        }
        this.getListData();
        Toast.clear();
      } else {
        let _this = this;
        szblMCom
          .getWxUserOpenId("hndxzs")
          .then((res) => {
            if (res.openid) {
              _this.openid = res.openid;
              _this.getListData();
              localStorage.setItem("openidStorage", JSON.stringify({ openid: _this.openid }));
            } else {
              Toast("获取不到微信信息，请重新获取");
            }
            this.readLocalStorage();
            // console.log('res', res, 'openid', res.openid)
            // console.log('this.openid', this.openid)
          })
          .catch((msg) => {
            Toast(msg);
          });
      }
    },

    //图片压缩
    imgys(event) {
      if (/\/(?:jpeg|png|jpg)/i.test(event.file.type) && event.file.size > 500000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = event.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 1000;
          canvas.height = 1000;
          //  drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
          // 如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。
          context.drawImage(img, 0, 0, 1000, 1000);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          // console.log(event.file.type);//格式image/jpeg
          event.content = canvas.toDataURL(event.file.type, 0.92);
          console.log("base64:", event.content); //base64位
        };
      }
      return event.content;
    },
    //到访校区点击
    onConfirmDd(value) {
      this.dfdd = value;
      this.showPickerDd = false;
    },

    //弹出开始时间框
    onConfirmKssj(value) {
      // console.log('value',value)
      // console.log('nextime',this.maxDate   )
      if (value.getTime() > this.maxDate.getTime()) {
        this.fwkssj = this.getDateFun(this.maxDate);
      } else {
        this.fwkssj = this.getDateFun(value);
      }

      this.showPickerKssj = false;
    },
    /*     onConfirmJssj(value) {
                     this.fwjssj = this.getDateFun(value);
                     this.showPickerJssj = false;
                 },*/
    //证件类型点击P
    onConfirmZjlx(value) {
      this.zjlx = value;
      this.showPickerZjlx = false;
    },
    //调教校验和生成参数信息
    onSubmit(values) {
      if (!this.openid) {
        Toast("获取不到微信信息，请重新获取");
      } else if (!this.bfrdw) {
        Toast("查询不到被访人信息，无法提交！");
      } else {
        // console.log(values)
        let obj = {
          bfrdw: this.bfrdw,
          fwjssj: this.jssjDateFun(values.fwts),
          openid: this.openid,
        };
        // console.log("values.fwkssj", values.fwkssj, obj.fwjssj);
        //
        if (this.clhm.length >= 7) {
          let pzdata = this.pzData;
          this.getRqjy(values.fwkssj, this.jssjDateFun(values.fwts)); //校验日期
          if (!this.isRqYY) {
            Dialog.alert({
              message: `${pzdata.JZYY_KS}到${pzdata.JZYY_JS}的日期，车辆不可预约,请清除车牌号，重新提交`,
            }).then(() => {
              this.clhm = "";
              this.inputCPH = "琼";
              this.cphArr = ["琼"];
            });
          } else {
            this.infoList = Object.assign(values, obj);
            // console.log("info", this.infoList);
            this.dialogShow = true; //显示弹窗
          }
        } else {
          this.infoList = Object.assign(values, obj);
          // console.log("info", this.infoList);
          this.dialogShow = true; //显示弹窗
        }

        // this.submitData(this.infoList)
      }
    },
    //提交
    submitData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      if (this.pzData.SFZJYZT == "1") {
        this.verify();
      } else {
        this.add();
        // console.log("this.infoList", _this.infoList);
      }
    },
    add() {
      let _this = this;
      szblMCom
        .ajaxPost("/api/jxyyapi?type=add", this.infoList)
        .then(function (res) {
          if (res.code == 0) {
            Toast.clear();
            Toast.success(res.msg);
            // Toast(res.msg);
            _this.saveLocalStorage();
          } else {
            Toast.clear();
            Toast.fail(res.msg);
          }
        })
        .catch(function (msg) {
          Toast(msg);
        });
    },
    //身份校验后提交
    verify() {
      let _this = this;
      // console.log("info", this.infoList);
      szblMCom
        .ajaxPost("/api/fywjxyy?type=verify", {
          zjlx: this.infoList.zjlx,
          zjhm: this.infoList.zjhm,
          fkxm: this.infoList.fkxm,
        })
        .then(function (res) {
          if (res.code == 0) {
            _this.add();
          } else {
            Toast.clear();
            Toast.fail(res.msg);
          }
        })
        .catch(function (msg) {
          Toast(msg);
        });
    },
    //对比校验时间是否已经重复提交
    checkRepeat() {
      // console.log("this.fwkssj", this.fwkssj);
      if (this.listData.length > 0) {
        for (let i = 0; i < this.listData.length; i++) {
          //比对年
          if (this.listData[i].FWKSSJ.substr(0, 4) == this.fwkssj.substr(0, 4)) {
            if (this.fwkssj == this.listData[i].FWKSSJ && this.listData[i].SHZT == "0") {
              Toast("该访问日期已存在申请，请勿重复提交");
              this.fwkssj = "";
              this.fwjssj = "";
            }
          } else {
            return;
          }
        }
      }
    },
    //获取申请列表
    getListData() {
      let _this = this;
      const jsons = {
        openid: this.openid,
      };
      szblMCom
        .ajaxPost("/api/jxyyapi?type=mylist", jsons)
        .then(function (res) {
          if (res.code === 0) {
            let data = JSON.parse(res.data);
            if (data.length > 0) {
              _this.listData = data;
            }
            Toast.clear();
            // console.log("预约信息数据/api/jxyyapi?type=mylist", res, data);
          }
        })
        .catch(function (msg) {
          console.log(msg);
        });
    },
    //提交成功清空数据
    clearData() {
      this.bfrdh = "";
      this.bfrxm = "";
      this.bfrdw = "";
      this.bfrdwmc = "";
      this.fkxm = "";
      this.fkdh = "";
      this.zjhm = "";
      this.fkszdw = "";
      this.clhm = "";
      this.xsxm = "";
      this.xsxh = "";
      this.xsyx = "";
      this.fwkssj = "";
      this.fwjssj = "";
      this.fwts = "1";
      this.bfsy = "";
      this.uploaderhsbg = [];
      this.uploaderjkm = [];
      this.uploaderxcm = [];
      this.jkm = "";
      this.xcm = "";
      this.hsbg = "";
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
      if (errorInfo) {
        Toast("请填写必填选项！");
      }
    },
    //显示弹框
    showPopup() {
      // document.activeElement.blur()//调用失去焦点方法阻止输入法虚拟软件弹出
      this.getData();
      this.popShow = true;
      this.dwReadonly = true;
      this.showRadio = true;
    },
    //查询单位数据
    getData(dwmc) {
      let _this = this;
      const jsons = {
        deptname: dwmc ? dwmc : "",
      };
      szblMCom
        .ajaxPost("/api/jxyyapi?type=dept", jsons)
        .then(function (res) {
          if (res.code === 0) {
            let data = JSON.parse(res.data);
            _this.dwInfo = data;
            // console.log('查询单位数据', res, data)
          }
        })
        .catch(function (msg) {
          console.log(msg);
        });
    },

    radioChange(val) {
      this.bfrdw = val;
      console.log(this.bfrdw);
    },
    onSearch(e) {
      console.log(this.searchValue, e);
      this.showRadio = true;
      this.getData(this.searchValue);
    },
    //弹窗隐藏
    onCancel() {
      if (!this.bfrdwmc) {
        Toast("请选择被访人单位!");
      } else {
        this.popShow = false;
      }
    },
    //被访人电话输入查询信息
    bfrdhClick() {
      let _this = this;
      // console.log('bfrdh', _this.bfrdh)
      const jsons = {
        phone: _this.bfrdh,
      };
      szblMCom
        .ajaxPost("/api/jxyyapi?type=jzg", jsons)
        .then(function (res) {
          if (res.code === 0) {
            let data = JSON.parse(res.data);
            if (data) {
              _this.bfrdw = data[0].DEPT_CODE;
              _this.bfrdwmc = data[0].DEPT_NAME;
              _this.bfrxm = data[0].USER_NAME;
              // console.log()
            } else {
              Toast("查询不到被访人信息");
              _this.bfrdw = "";
              _this.bfrdwmc = "";
              _this.bfrxm = "";
              // _this.bfrdw = "cs";
              // _this.bfrdwmc = "测试";
              // _this.bfrxm = "测试";
            }
          }
        })
        .catch(function (msg) {
          Toast("查询不到被访人信息");
          _this.bfrdw = "";
          _this.bfrdwmc = "";
          _this.bfrxm = "";
          console.log(msg);
        });
    },
    xhClick() {
      let _this = this;
      // console.log('xsxh', _this.xsxh)
      const jsons = {
        xh: _this.xsxh,
      };
      szblMCom
        .ajaxPost("/api/jxyyapi?type=xs", jsons)
        .then(function (res) {
          if (res.code === 0) {
            let data = JSON.parse(res.data);
            if (data.length > 0) {
              _this.xsxm = data[0].USER_NAME;
              _this.xsyx = data[0].DEPT_NAME;
            }
            console.log("查询账号学生数据", res, data[0]);
          }
        })
        .catch(function (msg) {
          console.log(msg);
        });
    },
    //证件类型效验
    validator(val) {
      if (this.zjlx === "身份证") {
        return this.isCardID(val);
      } else if (this.zjlx === "军官证") {
        return /^[a-zA-Z0-9]{7,21}$/.test(val);
      } else if (this.zjlx === "护照") {
        return /^[a-zA-Z0-9]{3,21}$/.test(val);
      } else if (this.zjlx === "港澳通行证") {
        return /^[a-zA-Z0-9]{5,21}$/.test(val);
      }
    },
    getSJPz() {
      const jsons = {
        openid: this.openid,
      };
      szblMCom
        .ajaxPost("/api/fywjxyy?type=pzinfo", jsons)
        .then((res) => {
          if (res.code == 0) {
            let data = szblMCom.strResToJson(res.data);
            this.pzData = data;
            console.log("pzData", data);
          }
        })
        .catch((msg) => {
          console.log("msg", msg);
          // Toast(msg)
        });
    },
    //不可预约日期段校验,校验通过返回true，校验不通过返回false
    getRqjy(yykssj, yyjssj) {
      let pzdata = this.pzData;
      this.isRqYY = false;
      if (pzdata.JZYY_KS && pzdata.JZYY_JS) {
        let yyksjTime = new Date(yykssj).getTime();
        let yyjsjTime = new Date(yyjssj).getTime();
        let ksTime = new Date(pzdata.JZYY_KS + " " + "00:00:00").getTime();
        let jsTime = new Date(pzdata.JZYY_JS + " " + "23:59:59").getTime();
        if ((yyksjTime >= ksTime && yyksjTime <= jsTime) || (yyjsjTime >= ksTime && yyjsjTime <= jsTime)) {
          // if (pzdata.JZYY_KS == pzdata.JZYY_JS) {
          //   Toast(`${pzdata.JZYY_KS}的日期车辆不可预约`);
          // } else {
          //   Toast(`${pzdata.JZYY_KS}到${pzdata.JZYY_JS}的日期不可预约`);
          // }
          this.isRqYY = false;
        } else {
          this.isRqYY = true;
        }
      } else {
        this.isRqYY = true;
      }
    },
    //获取结束时间
    jssjDateFun: function (ts) {
      let time = ts ? (ts - 1) * (24 * 60 * 60 * 1000) : 0;
      var date = new Date(this.fwkssj.replace(/-/g, "/")).getTime() + time;
      date = new Date(date);
      // console.log("date", date);
      let currentDate, //存日期（年月日）
        seperator = "-", // 如果想要其他格式 只需 修改这里
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      month >= 1 && month <= 9 ? (month = "0" + month) : "";
      day >= 0 && day <= 9 ? (day = "0" + day) : "";
      //当前 日期
      currentDate = year + seperator + month + seperator + day + " " + "23:59:59";
      //当前 时间
      // console.log("返回离校日期", currentDate);
      return currentDate;
    },
    //获取时间(转格式)
    // 目前输出格式 为 年-月-日 时:分:秒
    getDateFun(datetime) {
      // console.log('time',datetime)
      let date = datetime ? new Date(datetime) : new Date(),
        currentDate, //存日期（年月日）
        currentTime, //存时间（时分秒）
        seperator = "-", // 如果想要其他格式 只需 修改这里
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      month >= 1 && month <= 9 ? (month = "0" + month) : "";
      day >= 0 && day <= 9 ? (day = "0" + day) : "";
      //当前 日期
      currentDate = year + seperator + month + seperator + day;
      //当前 时间
      currentTime = hour + ":" + minute + ":" + second;
      let allDate = currentDate + " " + currentTime;
      return allDate;
    },
    //第二天
    nextDateFun() {
      let time = new Date(this.getDateFun().replace(/-/g, "/")).getTime() + 1000 * 60 * 60 * 24;
      // console.log(time)
      let date = new Date(time),
        currentDate, //存日期（年月日）
        currentTime, //存时间（时分秒）
        seperator = "/", // 如果想要其他格式 只需 修改这里
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      // hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
      //     minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
      //     second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      month >= 1 && month <= 9 ? (month = "0" + month) : "";
      day >= 0 && day <= 9 ? (day = "0" + day) : "";
      // console.log('date',date)
      //当前 日期
      currentDate = year + seperator + month + seperator + day;
      //当前 时间
      // currentTime = hour + ":" + minute + ":" + second;
      currentTime = "00:00:00";
      let allDate = currentDate + " " + currentTime;
      // var allDate = currentDate
      // console.log(allDate)
      return allDate;
    },

    //车辆输入点击
    clClick() {
      document.activeElement.blur(); //调用失去焦点方法阻止输入法虚拟软件弹出
      if (!this.clDilog) {
        Dialog.alert({
          title: "填写须知",
          confirmButtonText: "我已知晓",
          message: "若是系统内的车辆，请不要做车辆预约，否则会产生收费。",
        }).then(() => {
          this.clDilog = true;
          this.isShow = true;
          // console.log('车辆点击')
        });
      } else {
        this.isShow = true;
      }
    },
    //车牌输入处理
    vehicleTap(event) {
      // console.log(event);
      switch (event) {
        case "delete":
          this.inputchange(event);
          break;
        case "ok":
          this.ok();
          break;
        case "exit":
          this.exit();
          break;
        default:
          this.inputchange(event);
      }
    },
    //中英切换
    /*  check () {
                  if (this.keyBoardType == 1) {
                      this.keyBoardType = 2;
                  } else if (this.keyBoardType == 2) {
                      this.keyBoardType = 1;
                  }
              },*/
    /**
     * @params isShow 控制键盘显示隐藏
     * @prarms inputCPH   在键盘上显示输入的内容
     * @methods delete 删除按钮触发  this.inputCPH= this.inputCPH.slice(0, this.inputCPH.length-1)
     * @methods ok     确认 按钮触发
     * @methods exit   取消按钮触发
     * @methods inputchange 获取输入的内容
     */
    //取消按钮触发
    exit() {
      this.isShow = false;
      this.disabled = false;
      this.cphArr = ["琼"];
      this.inputCPH = "琼";
      this.keyBoardType = 2;
    },
    //获取输入的内容
    inputchange(val) {
      console.log("输入值", val);
      if (this.inputCPH.length >= 8 && val != "delete") {
        Toast("最多8位");
        return false;
      }
      //删除按钮触发
      if (val == "delete") {
        this.cphArr.pop(val);
        this.inputCPH = this.inputCPH.slice(0, this.inputCPH.length - 1);
        if (this.inputCPH.length < 1) {
          this.keyBoardType = 1;
        }
      } else {
        //默认输入
        this.cphArr.push(val);
        this.inputCPH += val;
        if (this.inputCPH.length >= 1) {
          this.keyBoardType = 2;
        }
      }
    },
    // 确认 按钮触发
    ok: function () {
      if (this.inputCPH.length < 7) {
        Toast("不少于七位");
        return false;
      }
      this.isShow = false;
      this.disabled = false;
      this.clhm = this.inputCPH;
      console.log(this.inputCPH, "点击确定", this.clhm);
    },
    //身份证效验
    isCardID(sId) {
      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(sId)) {
        console.log("你输入的身份证长度或格式错误");
        return false;
      }
      //身份证城市
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外",
      };
      if (!aCity[parseInt(sId.substr(0, 2))]) {
        console.log("你的身份证地区非法");
        return false;
      }

      // 出生日期验证
      var sBirthday = (sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2))).replace(/-/g, "/"),
        d = new Date(sBirthday);
      if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) {
        console.log("身份证上的出生日期非法");
        return false;
      }
      // 身份证号码校验
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
      for (var i = 0; i < sId.length - 1; i++) {
        sum += sId[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
      if (sId[sId.length - 1] != last) {
        console.log("你输入的身份证号非法");
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped lang="less">
@import "../../assets/plate-input.less";

.nav {
  position: fixed;
  top: 0;
  width: 100%;
  background: rgb(25 97 194);
  height: 86px;
  text-align: center;
  z-index: 33;

  .nav-loge {
    position: fixed;
    left: 16px;
    /*margin-left: 16px;*/
    margin-top: 6px;
    /*height: 60px;*/
  }

  .nav-ttile {
    margin-top: 46px;
    /*position: relative;*/
    /*line-height: 98px;*/
    font-size: 18px;
    color: #fafafa;
  }
}

.main {
  overflow: scroll;

  .bgheader {
    background: rgb(25 97 194);
    height: 176px;
  }

  .form-bg {
    padding: 0 18px 0 18px;

    .form-container {
      margin-top: -82px;
      .card {
        overflow: hidden;
        background: #ffffff;
        border-radius: 7px;
        margin-bottom: 18px;
        .card-title {
          padding: 16px 16px 14px 16px;
          display: flex;
          align-items: center;
          .card-text {
            margin-left: 6px;
            font-size: 16px;
            line-height: 25px;
          }
          .card-star {
            margin-left: 2px;
            font-size: 18px;
            line-height: 30px;
            color: red;
          }
        }
      }
    }
  }
}

.radioPop {
  /*height: 72%;*/
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/*.van-cell--required::before{*/
/*    font-size: 18px !important;*/
/*}*/

.drxx {
  padding: 10px 16px;
  font-size: 14px;
}
</style>
